import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    withIonLifeCycle,
    IonItem,
    IonBadge,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardSubtitle,
    IonCardContent,
    IonButtons,
    IonRow,
    IonBackButton,
    IonModal,
    IonList,
    IonCol,
    IonContent,
    IonGrid,
    IonAvatar,
    IonHeader, IonPopover, IonDatetime, IonThumbnail, IonFooter, IonItemGroup, IonPage, IonTitle, IonToolbar, IonSegment, IonSegmentButton, IonLabel, IonRippleEffect, IonButton, IonSearchbar, IonIcon
} from '@ionic/react';
import { } from 'ionicons/icons';
import { getContact, getShoppingCart, getTransactions, getTransactionTaxDisc, getLoginApp, getTransactionPayments } from '../../../utils/functions';
import { trashBin, trash, home, create, list, arrowUp, funnel, heart, cartSharp, cartOutline, business, barcode, person, podium, closeOutline, search, add, ticketOutline, receiptOutline, personOutline, callOutline, logoWhatsapp, locationOutline, mapOutline, car, colorFill } from 'ionicons/icons';
import PosActions from '../../../actions/PosActions';
import Select from 'react-select';

import Moment from 'react-moment';
import moment from 'moment';
import { Printer } from '@bcyesil/capacitor-plugin-printer';

import {
    queryAllPermisions
} from "../../../data_base_local/dataservice";
import { baseurl } from '../../../constants/constants';
import { Capacitor } from '@capacitor/core';
import { Link } from "react-router-dom";

const options2 = { style: 'currency', currency: 'USD', useGrouping: false };
const _numberFormat = new Intl.NumberFormat('en-US', options2);

interface IProps {
    post_: any;
    get_: any;
    setData_: any;
    removedshoppingcart: any;
}

interface IState {
    contact: any;
    shoppingcart: any;
    data_velues: any;
    modalPaymentShow: any;
    data_default: any;
    cash_register_util: any;
    payments: any;
    id_payment: any;

    currencyprimary: any;
    primary_label: any;

    currencysecondary: any;
    secondary_label: any;

    rate: any;
    secondary_operation: any;

    payment_types_is_secondary: any;
    payment_types_key: any;
    isOpenTransactionDate: any;
    data_login_ari_app: any;
    transaction_date: any;
    arraytransaction: any;
    pos_settings: any;
    contact_eventual: any;
    taxes: any;
    modaltaxDescShow: any;

    discount_type: any;
    discount_amount: any;
    tax_id: any;
    tax_amount: any;
    tax_calculation_amount: any;

    pos_location_id: any;
}

class Cart extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props)
        this.state = {
            data_default: props.data_default,
            cash_register_util: props.cash_register_util,
            contact: props.contact,
            shoppingcart: props.shoppingcart,
            data_velues: props.data_velues,
            modalPaymentShow: props.modalPaymentShow,
            payments: props.payments,
            id_payment: props.id_payment,
            rate: props.rate,
            currencyprimary: props.currencyprimary,
            primary_label: props.primary_label,
            currencysecondary: props.currencysecondary,
            secondary_label: props.secondary_label,
            secondary_operation: props.secondary_operation,

            payment_types_is_secondary: props.payment_types_is_secondary,
            payment_types_key: props.payment_types_key,
            isOpenTransactionDate: props.isOpenTransactionDate,
            transaction_date: props.transaction_date,
            data_login_ari_app: props.data_login_ari_app,
            arraytransaction: props.arraytransaction,
            pos_settings: props.pos_settings,
            contact_eventual: props.contact_eventual,
            taxes: props.taxes,
            modaltaxDescShow: props.modaltaxDescShow,

            //datos de la transaccion
            discount_type: props.discount_type,
            discount_amount: props.discount_amount,
            tax_id: props.tax_id,
            tax_amount: props.tax_amount,
            tax_calculation_amount: props.tax_calculation_amount,
            pos_location_id: props.pos_location_id

        };
    }

    ionViewWillEnter() {
        console.log('ionViewWillEnter 1 Cart');
        this.componentDidMount();
    }
    ionViewDidEnter() {
        //console.log('ionViewDidEnter 2 Cart');
    }
    ionViewWillLeave() {
        //console.log('ionViewWillLeave 3 Cart');
    }
    ionViewDidLeave() {
        //console.log('ionViewDidLeave 4 Cart');
    }

    async componentDidMount() {

        if (Capacitor.isNativePlatform()) {
            this.ValidatePermission();
        }

        let contact = getContact();
        let arrayshoppingcart = !getShoppingCart() ? [] : getShoppingCart();
        let data_login_ari_app: any = !getLoginApp() ? [] : getLoginApp();
        let data_transactiotaxdic: any = !getTransactionTaxDisc() ? false : getTransactionTaxDisc();
        if (!data_transactiotaxdic) {
            data_transactiotaxdic = {
                discount_type: 'fixed',
                discount_amount: 0,
                tax_id: null,
                tax_amount: 0,
                tax_calculation_amount: 0,
            }
        }

        let ari_app_transaction_payments = !getTransactionPayments() ? [
            {
                label: 'cash',
                id: 'cash',
                amount: 0,
                secondary: 0,
                transaction_no_2: '',
                note: '',
                is_secondary: 0

            }
        ] : getTransactionPayments();

        ari_app_transaction_payments = ari_app_transaction_payments.length == 0 ? [
            {
                label: 'cash',
                id: 'cash',
                amount: 0,
                secondary: 0,
                transaction_no_2: '',
                note: '',
                is_secondary: 0

            }
        ] : ari_app_transaction_payments;

        let arraytransaction = !getTransactions() ? null : getTransactions();
        console.log(data_transactiotaxdic, 'data_transactiotaxdic');
        this.setState({

            //datos de la transaccion
            discount_type: data_transactiotaxdic.discount_type,
            discount_amount: data_transactiotaxdic.discount_amount,
            tax_id: data_transactiotaxdic.tax_id,
            tax_amount: data_transactiotaxdic.tax_amount,
            tax_calculation_amount: data_transactiotaxdic.tax_calculation_amount,

            modaltaxDescShow: false,
            modalPaymentShow: false,
            isOpenTransactionDate: false,
            arraytransaction: arraytransaction,

            contact: contact,
            shoppingcart: arrayshoppingcart,
            transaction_date:
                arraytransaction ?
                    moment(arraytransaction.transaction_date, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD") :
                    moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            data_velues: {
                sub_total: 0,
                total_discount: 0,
                total_taxes: 0,
                final_total: 0,
                final_total_secondary: 0,
                total_paid: 0,
                total_paid_secondary: 0,
                total_return: 0,
                total_return_secondary: 0,
                total_rest: 0,
                total_rest_secondary: 0,
                //price_group: price_group,
                //selling_price_may_id: selling_price_may_id
            },
            data_login_ari_app: data_login_ari_app,
            payments: ari_app_transaction_payments ? ari_app_transaction_payments : [
                {
                    label: 'cash',
                    id: 'cash',
                    amount: 0,
                    secondary: 0,
                    transaction_no_2: '',
                    note: ''
                }
            ],

            id_payment: null

        });

        setTimeout(this.refreshTotalShipping.bind(this), 100);

    }

    /*necesario para validar permisos*/
    async ValidatePermission() {

        let dataPermissions: any = await queryAllPermisions().then();
        let is_valid = true;
        if (dataPermissions && dataPermissions.values.length > 0) {
            dataPermissions.values.map((val: any, key: any) => {
                if (val.status !== 'active') {
                    is_valid = false;
                }
            });
        } else {
            is_valid = false;
        }

        if (!is_valid) {
            window.location.href = baseurl() + "/home";
        }
    };
    /* fin necesario para validar permisos*/

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            data_default: nextProps.data.data_default,
            cash_register_util: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util : null,

            rate: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.rate : 1,
            currencyprimary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencyprimary : '',
            primary_label: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.primary_label : 'primary',
            currencysecondary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencysecondary : '',
            secondary_label: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.secondary_label : 'secondary',
            secondary_operation: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.secondary_operation : '*',

            payment_types_is_secondary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.payment_types_is_secondary : [],
            payment_types_key: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.payment_types_key : [],

            pos_settings: nextProps.data.data_default && nextProps.data.data_default.pos_settings ? nextProps.data.data_default.pos_settings : null,
            contact_eventual: nextProps.data.data_default && nextProps.data.data_default.contact_eventual ? nextProps.data.data_default.contact_eventual : null,
            taxes: nextProps.data.data_default && nextProps.data.data_default.taxes ? nextProps.data.data_default.taxes : [],
            pos_location_id: nextProps.data.pos_location_id ? nextProps.data.pos_location_id :
                nextProps.data.data_default && nextProps.data.data_default.cash_register_util && nextProps.data.data_default.cash_register_util.current_register ?
                    nextProps.data.data_default.cash_register_util.current_register.location_id : null,
        });
        console.log(nextProps.data, 'dashboard_pos/cart', nextProps.data.pos_location_id);
        if (nextProps.data.view_active == 'dashboard_pos/cart') {
            if (nextProps.data.refresh_list) {
                //clean cart
                if (nextProps.data.response && nextProps.data.response.success) {
                    if (nextProps.data.data_default && nextProps.data.data_default.contact_eventual) {
                        window.localStorage.setItem('ari_app_contact', JSON.stringify(nextProps.data.data_default.contact_eventual));
                    } else {
                        window.localStorage.removeItem('ari_app_contact');
                    }
                    window.localStorage.setItem('ari_app_shoppingcart', JSON.stringify([]));
                    window.localStorage.removeItem('ari_app_transaction');
                    window.localStorage.removeItem('ari_app_transaction_payments');
                    window.localStorage.removeItem('data_transactiotaxdic');

                    setTimeout(this.componentDidMount.bind(this), 100);
                }
            }
            setTimeout(this.refreshTotalShipping.bind(this), 100);

            if (this.state.taxes != (nextProps.data.data_default && nextProps.data.data_default.taxes ? nextProps.data.data_default.taxes : [])) {
                setTimeout(this.componentDidMount.bind(this), 100);
            }

            if (nextProps.data.response && nextProps.data.response.success && nextProps.data.response.receipt) {
                setTimeout(this.printTransaction.bind(this, nextProps.data.response.receipt), 100);

            }
        }

    }
    printTransaction(html: any) {
        if (Capacitor.isNativePlatform()) {
            Printer.print({ content: html, name: 'lorem-filename', orientation: 'portrait' })
                .then((res: any) => {
                    console.log(res);
                    this.props.setData_({ response: {}, simpleToast: false });
                })
                .catch((err: any) => {
                    console.error(err);
                    this.props.setData_({ response: {}, simpleToast: false });

                });
        } else {
            const printFrame = document.createElement('iframe');
            printFrame.style.position = 'fixed';
            printFrame.style.right = '0';
            printFrame.style.bottom = '0';
            printFrame.style.width = '0';
            printFrame.style.height = '0';
            printFrame.style.border = '0';
            printFrame.srcdoc = html;
            // Insertar el iframe en el div print-area en lugar de document.body
            const printArea = document.getElementById('print-area');
            if (printArea) {
                printArea.appendChild(printFrame);
            } else {
                document.body.appendChild(printFrame);
            }

            printFrame.onload = () => {
                printFrame.contentWindow?.focus();
                printFrame.contentWindow?.print();
                setTimeout(() => {
                    if (printFrame.parentNode === document.body) {
                        document.body.removeChild(printFrame);
                    } else if (printFrame.parentNode) {
                        printFrame.parentNode.removeChild(printFrame);
                    }
                }, 3000);
            };

            this.props.setData_({ response: {}, simpleToast: false });
        }
    }
    render_shoppingcart(row: any, key: any) {
        return (
            <IonCol col-12 size='12' key={key} className='card_line'>

                <IonRow>
                    <IonCol col-11 size='11' style={{ textAlign: 'left' }} >
                        <strong className=''> {row.name}</strong>   <br />
                    </IonCol>
                    <IonCol col-1 size='1' style={{ textAlign: 'right' }} >
                        <IonIcon
                            style={{
                                color: "#E91E63",
                                fontSize: "25px",
                                verticalAlign: 'middle'
                            }}
                            onClick={(ev) => this.removedRowProduct(row)}
                            icon={trash} />
                    </IonCol>

                    <IonCol col-12 size='12' style={{ textAlign: 'left' }} >
                        <label className='text-g50 font-medium text-xs line-hei-150'><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> {row.sub_sku}</label>
                        {
                            row.variation != 'DUMMY' ? <><br /> <label className='text-g50 font-medium text-xs line-hei-150'><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> {row.variation}</label></> : null
                        }
                    </IonCol>
                    <IonCol col-11 size='11' style={{ textAlign: 'left' }}>
                        Precio: {_numberFormat.format(parseFloat(row.current_price_discount)).replace("$", "")} - Cant: {_numberFormat.format(parseFloat(row.quantity)).replace("$", "")} -   <IonBadge color={parseFloat(row.qty_available) > 0 ? "success" : "danger"}>Stock : {_numberFormat.format(row.qty_available).replace("$", "")}</IonBadge>
                        <br /> Sub-Total: {_numberFormat.format(parseFloat(row.current_price_discount) * parseFloat(row.quantity)).replace("$", "")}

                    </IonCol>
                    <IonCol col-1 size='1' style={{ textAlign: 'right' }} >
                        <IonIcon
                            style={{
                                color: "#1572e8",
                                fontSize: "25px",
                                verticalAlign: 'middle'
                            }}
                            icon={create}
                            onClick={() => this.setActionClientModalShow(row, key)}
                        />&nbsp;&nbsp;
                    </IonCol>
                </IonRow>
                <IonModal onWillDismiss={e => this.closemodalClientActions(row, key)} isOpen={row.modalOpen ?? false} trigger="open-modal" initialBreakpoint={0.50} breakpoints={[0, 0.50, 0.5, 0.75]}>
                    <IonHeader>
                        <IonToolbar>
                            <IonTitle>{row.name}</IonTitle>
                            <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={(ev) => this.closemodalClientActions(row, key)}>
                                <IonIcon icon={closeOutline}></IonIcon>
                            </IonButton>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent className="ion-padding">
                        <IonRow>
                            <IonCol col-6 size='6'>
                                Cantidad <br />
                                <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input' defaultValue={_numberFormat.format(parseFloat(row.quantity)).replace("$", "")} min="0" onChange={e => this.onChangeForValuesDetailsArrayProductFilter(key, e)} name="quantity" />
                            </IonCol>
                            <IonCol col-6 size='6'>
                                Precio Venta <br />
                                <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input' defaultValue={_numberFormat.format(parseFloat(row.current_price)).replace("$", "")} min="0" onChange={e => this.onChangeForValuesDetailsArrayProductFilter(key, e)} name="current_price" />
                            </IonCol>
                            <IonCol col-12 size='12'>
                                {
                                    row.sub_units && row.sub_units.length > 0 ?
                                        <Select
                                            onChange={(e: any) => this.onChangeForValuesDetailsArrayProductFilter(key, { target: { name: 'unit_id', value: e.value } })}
                                            placeholder="Sub Categoria"
                                            name='unit_id'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={
                                                row && row.sub_units && row.sub_units.map((option: any) => (
                                                    { label: option.name, value: option.id }
                                                ))
                                            }
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={row.unit_id ?
                                                row.sub_units && row.sub_units.length > 0 ?
                                                    { label: row.sub_units.filter((item: any) => item.id == row.unit_id)[0].name, value: row.sub_units.filter((item: any) => item.id == row.unit_id)[0].id }
                                                    : null
                                                : null
                                            }
                                        /> : null
                                }
                            </IonCol>
                            <IonCol col-6 size='6'>
                                Tipo de descuento <br />
                                {
                                    <Select
                                        onChange={(e: any) => this.onChangeForValuesDetailsArrayProductFilter(key, { target: { name: 'discount_type', value: e.value } })}
                                        placeholder="Tipo de descuento"
                                        name='discount_type'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        options={[
                                            { label: "Fijo", value: 'fixed' },
                                            { label: "Porcentaje", value: 'percentage' },
                                        ]}
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}
                                        defaultValue={row.discount_type ?
                                            row.discount_type == 'fixed' ? { label: "Fijo", value: 'fixed' } : { label: "Porcentaje", value: 'percentage' }
                                            :
                                            { label: "Fijo", value: 'fixed' }
                                        }
                                    />
                                }
                            </IonCol>
                            <IonCol col-6 size='6'>
                                Monto del Descuento <br />

                                <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                                    value={row.discount_amount} min="0" onChange={e => this.onChangeForValuesDetailsArrayProductFilter(key, e)} name="discount_amount" />
                            </IonCol>
                            <IonCol col-6 size='6'>
                                Stock : {_numberFormat.format(row.qty_available).replace("$", "")}
                            </IonCol>
                            <IonCol col-6 size='6'>
                                Sub-Total : {_numberFormat.format(parseFloat(row.current_price_discount) * parseFloat(row.quantity)).replace("$", "")}
                            </IonCol>
                        </IonRow>
                    </IonContent>
                </IonModal>
            </IonCol>
        );
    }

    setActionClientModalShow(row: any, index: any) {
        let shoppingcart = this.state.shoppingcart;

        const newArr = shoppingcart.map((item: any, i: any) => {
            if ((index) == i) {
                return {
                    ...item,
                    'modalOpen': true
                };
            } else {
                return item;
            }
        });

        this.setState({
            shoppingcart: newArr
        });
    }

    closemodalClientActions(row: any, index: any) {
        let shoppingcart = this.state.shoppingcart;

        const newArr = shoppingcart.map((item: any, i: any) => {
            if ((index) == i) {
                return {
                    ...item,
                    'modalOpen': false
                };
            } else {
                return item;
            }
        });
        window.localStorage.setItem('ari_app_shoppingcart', JSON.stringify(newArr));

        this.setState({
            shoppingcart: newArr
        });
    }

    removedRowProduct(product: any) {
        this.props.removedshoppingcart(product);
        let arrayshoppingcart = !getShoppingCart() ? [] : getShoppingCart();
        this.setState({
            shoppingcart: arrayshoppingcart
        });
        setTimeout(this.refreshTotalShipping.bind(this), 100);
    }

    onChangeForValuesDetailsArrayProductFilter(index: any, e: any) {
        let shoppingcart = this.state.shoppingcart;
        let new_shoppingcart: any = [];

        if (e.target.name == 'quantity') {
            const newArr = shoppingcart.map((item: any, i: any) => {
                let current_price = item.current_price;

                //3.precio mayorista
                /*let filter_price_array_units = item.sub_units.filter((item_filter: any) => item_filter.id == item.unit_id);
                if (filter_price_array_units.length > 0) {
                    if (parseFloat(item.factor) != 0 && (parseFloat(e.target.value) * parseFloat(filter_price_array_units[0].multiplier)) >= parseFloat(item.factor)) {
                        let filter_price_array_units_mayoristic = filter_price_array_units[0].price_groups_all.filter((item_filter: any) => item_filter.price_group_id == data_velues.selling_price_may_id);

                        if (filter_price_array_units_mayoristic.length > 0) {
                            current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(filter_price_array_units_mayoristic[0].price_inc_tax);
                        } else {
                            current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(filter_price_array_units[0]._price_group);
                        }
                    } else {
                        if (item.variation_group_price) {
                            current_price = parseFloat(item.variation_group_price);
                        } else {
                            current_price = parseFloat(item.default_sell_price);
                        }
                        let _price_group = parseFloat(filter_price_array_units[0]._price_group) == 0 ? current_price : parseFloat(filter_price_array_units[0]._price_group);
                        current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(_price_group);
                    }
                }*/

                //validar precio con el descuento
                let discount_amount = item.discount_amount;
                let type = item.discount_type;
                let current_price_discount = item.current_price_discount;

                if (type == 'fixed') {
                    current_price_discount = (current_price - discount_amount);
                } else {
                    current_price_discount = current_price - (current_price * (discount_amount / 100));
                }

                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                        ['current_price']: current_price,
                        ['current_price_discount']: current_price_discount,
                    };
                } else {
                    return item;
                }
            });
            new_shoppingcart = newArr;
        } else if (e.target.name == 'unit_id') {

            const newArr = shoppingcart.map((item: any, i: any) => {
                let current_price = item.current_price;

                //2. si cambia la unidad de medida cambiar a precio select.
                /*let filter_price_array_units = item.sub_units.filter((item_filter: any) => item_filter.id == e.target.value);
           
                if (filter_price_array_units.length > 0) {
                    if (parseFloat(item.factor) != 0 && (parseFloat(item.quantity) * parseFloat(filter_price_array_units[0].multiplier)) >= parseFloat(item.factor)) {
                        let filter_price_array_units_mayoristic = filter_price_array_units[0].price_groups_all.filter((item_filter: any) => item_filter.price_group_id == data_velues.selling_price_may_id);

                        if (filter_price_array_units_mayoristic.length > 0) {
                            current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(filter_price_array_units_mayoristic[0].price_inc_tax);
                        } else {
                            current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(filter_price_array_units[0]._price_group);
                        }
                    } else {
                        //2.1 validar si la unidad de medida tiene algun precio vinculado para usarlo.
                        if (filter_price_array_units[0]._price != 0) {
                            //2.3 si existe precio por unidad de medida se usa.
                            current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(filter_price_array_units[0]._price_group);
                        } else {
                            //2.4 como no existe precio vinculado a la unidad de medida se elije priorisando precio por grupo de precio sino precio default del producto.
                            if (item.variation_group_price) {
                                current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(item.variation_group_price);
                            } else {
                                current_price = parseFloat(filter_price_array_units[0].multiplier) * parseFloat(item.default_sell_price);
                            }
                        }
                    }
                }*/

                //validar precio con el descuento
                let discount_amount = item.discount_amount;
                let type = item.discount_type;
                let current_price_discount = item.current_price_discount;

                if (type == 'fixed') {
                    current_price_discount = (current_price - discount_amount);
                } else {
                    current_price_discount = current_price - (current_price * (discount_amount / 100));
                }

                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                        ['current_price']: current_price,
                        ['current_price_discount']: current_price_discount,

                    };
                } else {
                    return item;
                }
            });
            new_shoppingcart = newArr;


        } else if (e.target.name == 'discount_type') {
            let type = e.target.value;

            //otros campos no especiales
            const newArr = shoppingcart.map((item: any, i: any) => {
                let current_price = item.current_price;
                let current_price_discount = item.current_price_discount;

                if (type == 'fixed') {
                    current_price_discount = (current_price - item.discount_amount);
                } else {
                    current_price_discount = current_price - (current_price * (item.discount_amount / 100));
                }
                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                        ['current_price_discount']: current_price_discount,
                    };
                } else {
                    return item;
                }
            });
            new_shoppingcart = newArr;

        } else if (e.target.name == 'discount_amount') {
            let discount_amount = e.target.value;

            //otros campos no especiales
            const newArr = shoppingcart.map((item: any, i: any) => {
                let type = item.discount_type;

                let current_price = item.current_price;
                let current_price_discount = item.current_price_discount;

                if (type == 'fixed') {
                    current_price_discount = (current_price - discount_amount);
                } else {
                    current_price_discount = current_price - (current_price * (discount_amount / 100));
                }

                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                        ['current_price_discount']: current_price_discount,
                    };
                } else {
                    return item;
                }
            });
            new_shoppingcart = newArr;

        } else if (e.target.name == 'current_price') {

            //otros campos no especiales
            const newArr = shoppingcart.map((item: any, i: any) => {
                let type = item.discount_type;

                let current_price = e.target.value;
                let current_price_discount = item.current_price_discount;

                if (type == 'fixed') {
                    current_price_discount = (current_price - item.discount_amount);
                } else {
                    current_price_discount = current_price - (current_price * (item.discount_amount / 100));
                }

                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                        ['current_price_discount']: current_price_discount,
                    };
                } else {
                    return item;
                }
            });
            new_shoppingcart = newArr;

        } else {
            //otros campos no especiales
            const newArr = shoppingcart.map((item: any, i: any) => {
                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                    };
                } else {
                    return item;
                }
            });
            new_shoppingcart = newArr;

        }
        this.setState({
            shoppingcart: new_shoppingcart
        });

        window.localStorage.setItem('ari_app_shoppingcart', JSON.stringify(new_shoppingcart));

        setTimeout(this.refreshTotalShipping.bind(this), 100);
    }

    handleFocus(event: any) {
        event.target.select();
    }

    refreshTotalShipping() {

        let shoppingcart = this.state.shoppingcart;

        let data_velues = this.state.data_velues;

        let rate = this.state.rate;
        let secondary_operation = this.state.secondary_operation;

        let sub_total: any = 0;
        let total_discount: any = 0;

        shoppingcart.map((item: any, i: any) => {
            sub_total = parseFloat(sub_total) + (parseFloat(item.current_price) * parseFloat(item.quantity));
            total_discount = parseFloat(total_discount) + (parseFloat(item.current_price) - parseFloat(item.current_price_discount));
        });

        //taxes e impuestos por factura
        if (this.state.discount_type == 'fixed') {
            total_discount = parseFloat(total_discount) + parseFloat(this.state.discount_amount);
        } else {
            total_discount = parseFloat(total_discount) + (parseFloat(sub_total) * (parseFloat(this.state.discount_amount) / 100));
        }

        data_velues['sub_total'] = sub_total;
        data_velues['total_discount'] = total_discount;
        data_velues['total_taxes'] = 0;
        let tax_calculation_amount = 0;
        let filter_taxes = this.state.taxes.filter((item_filter: any) => item_filter.id == this.state.tax_id);
        if (filter_taxes.length > 0) {
            data_velues['total_taxes'] = ((parseFloat(sub_total) - parseFloat(total_discount)) * (parseFloat(filter_taxes[0].amount) / 100));
            tax_calculation_amount = parseFloat(filter_taxes[0].amount);
        }


        data_velues['final_total'] = parseFloat(sub_total) - parseFloat(total_discount) + parseFloat(data_velues['total_taxes']);

        let final_total_secondary: any = (secondary_operation == '/' ? (parseFloat(data_velues['final_total']) / parseFloat(rate)) : (parseFloat(data_velues['final_total']) * parseFloat(rate)));
        data_velues['final_total_secondary'] = parseFloat(final_total_secondary);

        //total del pago
        let payments = this.state.payments;
        let payment_types_is_secondary = this.state.payment_types_is_secondary;

        let total_paid: any = 0;
        let total_paid_secondary: any = 0;
        let total_return: any = 0;
        let total_return_secondary: any = 0;
        let total_rest: any = 0;
        let total_rest_secondary: any = 0;

        payments.map((item: any, i: any) => {
            if (payment_types_is_secondary[item.id] && payment_types_is_secondary[item.id] == 1) {
                //  / *
                total_paid += secondary_operation == "/" ? parseFloat(item.secondary) * parseFloat(rate) : parseFloat(item.secondary) / parseFloat(rate);
                total_paid_secondary += parseFloat(item.secondary);

            } else {
                //  / /
                total_paid_secondary += secondary_operation == "/" ? parseFloat(item.amount) / parseFloat(rate) : parseFloat(item.amount) * parseFloat(rate);
                total_paid += parseFloat(item.amount);

            }
        });

        total_rest = parseFloat(data_velues['final_total']) - parseFloat(total_paid);
        total_rest_secondary = parseFloat(data_velues['final_total_secondary']) - parseFloat(total_paid_secondary);
        if (total_rest < 0) {
            total_rest = 0;
            total_rest_secondary = 0;
        }

        total_return = parseFloat(total_paid) - parseFloat(data_velues['final_total']);
        total_return_secondary = parseFloat(total_paid_secondary) - parseFloat(data_velues['final_total_secondary']);

        if (total_return < 0) {
            total_return = 0;
            total_return_secondary = 0;
        }

        data_velues['total_paid'] = total_paid;
        data_velues['total_paid_secondary'] = total_paid_secondary;

        data_velues['total_return'] = total_return;
        data_velues['total_return_secondary'] = total_return_secondary;

        data_velues['total_rest'] = total_rest;
        data_velues['total_rest_secondary'] = total_rest_secondary;

        total_rest = 0;
        total_rest_secondary = 0;

        let data_transactiotaxdic: any = {
            discount_type: this.state.discount_type,
            discount_amount: this.state.discount_amount,
            tax_id: this.state.tax_id,
            tax_amount: data_velues['total_taxes'],
            tax_calculation_amount: tax_calculation_amount,
        };

        window.localStorage.setItem('data_transactiotaxdic', JSON.stringify(data_transactiotaxdic));

        this.setState({
            data_velues: data_velues,
            tax_amount: data_velues['total_taxes'],
            tax_calculation_amount: tax_calculation_amount
        });

    }

    sendOrder(type: any) {

        let arraytransaction = !getTransactions() ? null : getTransactions();
        let products: any = [];
        let arrayshoppingcart = !getShoppingCart() ? [] : getShoppingCart();
        let contact = this.state.contact;
        let data_velues = this.state.data_velues;
        let payments = this.state.payments;
        let pos_settings = this.state.pos_settings;

        let data_send = {
            user_id: this.state.data_login_ari_app.id,
            transaction_date: moment(this.state.transaction_date, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD") + " " + moment(new Date(), "YYYY-MM-DD hh:mm").format("hh:mm:ss"),

            status: 'final',
            contact_id: contact.id,
            final_total: data_velues.final_total,
            location_id: this.state.pos_location_id,
            additional_notes: null,
            nota: null,
            shipping_address: null,
            new_shipping_address: null,
            is_suspend: 1,
            is_credit_sale: 0,
            is_cataloge: 1,
            products: [],
            typeOption: 'saveOrder',
            action: 'create',
            type_pasarela: 1,
            payment: [],
            is_return: 0,
            change_return: 0,
            change_return_secondary: 0,
            transaction_id: null,
            is_direct_sale: 0,
            view_active: '',

            discount_type: this.state.discount_type,
            discount_amount: this.state.discount_amount,
            tax_rate_id: this.state.tax_id,
            tax_calculation_amount: 0,
            tax_amount: this.state.tax_amount,
        }

        if (type == 'is_suspend') {

            data_send.is_suspend = 1;
            data_send.is_credit_sale = 0;
            data_send.is_direct_sale = 0;

        } else if (type == 'is_credit_sale') {

            data_send.is_suspend = 0;
            data_send.is_credit_sale = 1;
            data_send.is_direct_sale = 0;

        } else if (type == 'quotation') {
            data_send.status = 'quotation';
            data_send.is_suspend = 0;
            data_send.is_credit_sale = 0;
            data_send.is_direct_sale = 0;
        } else if (type == 'preventa') {
            data_send.status = 'draft';
            data_send.is_suspend = 0;
            data_send.is_credit_sale = 0;
            data_send.is_direct_sale = 1;

        }

        if (!this.state.contact.id) {
            this.props.setData_({
                response: { Msg: "Debe Agregar cliente" },
                simpleToast: true
            });
            return false;
        }

        if (arrayshoppingcart.length == 0) {
            this.props.setData_({
                response: { Msg: "Debe Agregar Productos", succes: 0 },
                simpleToast: true
            });
            return false;
        }

        let allow_overselling = pos_settings.allow_overselling != undefined ? true : false;
        let allow_overselling_validacion = false;

        arrayshoppingcart.map((item: any, i: any) => {

            let quantity: any = item.quantity;
            let variation_id: any = item.id;
            let product_id: any = item.product_id;
            let line_discount_type: any = item.discount_type;
            let line_discount_amount: any = item.discount_amount;
            let unit_price: any = item.current_price;
            let unit_price_inc_tax: any = item.current_price_discount;

            let item_tax: any = 0;
            let tax_id: any = null;
            let tax_rate_id: any = null;

            let enable_stock: any = item.enable_stock;
            let product_type: any = item.type;
            let base_unit_multiplier: any = 1;
            let sub_unit_id: any = item.unit_id;
            let product_unit_id: any = item.unit_id;
            let dpp_inc_tax: any = item.dpp_inc_tax;

            let filter_price_array_units = item.sub_units.filter((item_filter: any) => item_filter.id == item.unit_id);
            if (filter_price_array_units.length > 0) {
                base_unit_multiplier = filter_price_array_units[0].multiplier;
            }

            if (!allow_overselling && (type != 'quotation' && type != 'preventa')) {
                if (parseFloat(item.qty_available) <= 0) {
                    allow_overselling_validacion = true;
                }
            }
            products.push(
                {
                    quantity: quantity,
                    variation_id: variation_id,
                    product_id: product_id,
                    line_discount_type: line_discount_type,
                    line_discount_amount: line_discount_amount,
                    unit_price: unit_price,
                    unit_price_inc_tax: unit_price_inc_tax,
                    item_tax: item_tax,
                    tax_id: tax_id,
                    tax_rate_id: tax_rate_id,
                    enable_stock: enable_stock,
                    product_type: product_type,
                    base_unit_multiplier: base_unit_multiplier,
                    sub_unit_id: sub_unit_id,
                    product_unit_id: product_unit_id,
                    dpp_inc_tax: dpp_inc_tax,
                    unit_cost: dpp_inc_tax
                }
            );

        });

        data_send.products = products;

        let validate_payments: any = payments;

        if (payments.length == 1) {
            payments.map((item: any, i: any) => {
                if (i == 0 && parseFloat(item.amount) == 0) {
                    validate_payments = [];
                    item.secondary = data_velues.final_total_secondary;
                    item.amount = data_velues.final_total;
                    validate_payments.push(item);
                }
            });
        }

        if (type == 'is_payment_exist') {
            data_send.payment = validate_payments;
            data_send.is_suspend = 0;
            data_send.is_credit_sale = 0;
        }

        if (this.state.data_velues.total_return > 0) {
            data_send.is_return = 1;
            data_send.change_return = this.state.data_velues.total_return;
            data_send.change_return_secondary = this.state.data_velues.total_return_secondary;
        }

        data_send.view_active = 'dashboard_pos/cart';
        if (allow_overselling_validacion) {

            this.props.setData_({
                response: { Msg: "Validar stock de Productos", succes: 0 },
                simpleToast: true
            });
            return false;

        } else {
            if (arraytransaction) {
                data_send.transaction_id = arraytransaction.transaction_id;
                this.props.post_(data_send, "api/updateOrder");
            } else {
                this.props.post_(data_send, "api/saveOrder");
            }

        }

    }

    closemodalPayment() {

        this.setState({
            modalPaymentShow: false
        });

    }

    openmodalPayment() {
        let data_velues = this.state.data_velues;

        let payments = this.state.payments;
        let init_payments: any = [];

        if (payments.length == 1) {
            let edit = 0;
            payments.map((item: any, i: any) => {

                if (i == 0 && parseFloat(item.amount) == 0) {
                    item.secondary = data_velues.final_total_secondary;
                    item.amount = data_velues.final_total;
                    init_payments.push(item);
                    edit = 1;
                }

            });

            if (edit) {
                this.refreshTotalShipping();
                this.setState({
                    modalPaymentShow: true,
                    payments: init_payments
                });
            } else {
                this.setState({
                    modalPaymentShow: true,
                });
            }

        } else {
            this.setState({
                modalPaymentShow: true,
            });
        }

    }

    closemodaltaxDesc() {
        this.setState({
            modaltaxDescShow: false
        });
    }

    openmodaltaxDesc() {
        this.setState({
            modaltaxDescShow: true,
        });
    }

    addPayment() {
        let id_payment = this.state.id_payment;
        let payments = this.state.payments;

        if (id_payment) {
            //verificar si ya existe el pago agregado
            let payments_filter = payments.filter((item_filter: any) => item_filter.id == id_payment);
            if (payments_filter.length == 0) {
                let payment_types = (this.state.cash_register_util && this.state.cash_register_util.payment_types && this.state.cash_register_util.payment_types) ?? [];
                if (payment_types.length > 0) {
                    let filter_payment_types = payment_types.filter((item_filter: any) => item_filter.id == id_payment);
                    if (filter_payment_types.length > 0) {
                        payments.push(
                            {
                                label: filter_payment_types[0].label,
                                amount: 0,
                                secondary: 0,
                                transaction_no_2: '',
                                note: '',
                                id: filter_payment_types[0].id,
                                payment_id: filter_payment_types[0].payment_id,
                                is_secondary: this.state.payment_types_is_secondary[filter_payment_types[0].id] ?? 0
                            }
                        );
                        this.setState({
                            payments: payments
                        });
                    }
                }
            } else {
                if (payments_filter[0].label == 'cash') {
                    let payment_types = (this.state.cash_register_util && this.state.cash_register_util.payment_types && this.state.cash_register_util.payment_types) ?? [];
                    if (payment_types.length > 0) {
                        let filter_payment_types = payment_types.filter((item_filter: any) => item_filter.id == 'cash');
                        if (filter_payment_types.length > 0) {

                            this.props.setData_({
                                response: { Msg: "ya esta agregado este metodo de pago: " + filter_payment_types[0].label },
                                simpleToast: true
                            });
                        }
                    }
                } else {
                    this.props.setData_({
                        response: { Msg: "ya esta agregado este metodo de pago: " + payments_filter[0].label },
                        simpleToast: true
                    });
                }
            }


        }
    }

    removedPayment(index: any) {
        let payments: any = [];
        this.state.payments.map((item: any, i: any) => {
            if (i != index) {
                payments.push(item);
            }
        });
        this.setState({
            payments: payments
        });

    }

    handleChangeDefault(event: any) {

        this.setState({
            ...this.state,
            [event.target.name]: event.target.value
        });

        setTimeout(this.refreshTotalShipping.bind(this), 100);

    }

    onChangeDetailsArrayPayment(index: any, e: any) {

        let payment = this.state.payments;
        let rate = this.state.rate;
        let secondary_operation = this.state.secondary_operation;
        let newArr: any = [];
        if (e.target.name == 'amount') {

            let secondary: any = secondary_operation == "/" ? parseFloat(e.target.value) / parseFloat(rate) : parseFloat(e.target.value) * parseFloat(rate);
            let amount: any = parseFloat(e.target.value);

            newArr = payment.map((item: any, i: any) => {
                if ((index) == i) {
                    return {
                        ...item,
                        'amount': amount,
                        'secondary': secondary,
                    };
                } else {
                    return item;
                }
            });

        } else if (e.target.name == 'secondary') {

            let amount: any = secondary_operation == "/" ? parseFloat(e.target.value) * parseFloat(rate) : parseFloat(e.target.value) / parseFloat(rate);
            let secondary: any = e.target.value;

            newArr = payment.map((item: any, i: any) => {
                if ((index) == i) {
                    return {
                        ...item,
                        'amount': amount,
                        'secondary': secondary,
                    };
                } else {
                    return item;
                }
            });

        } else {
            newArr = payment.map((item: any, i: any) => {
                if ((index) == i) {
                    return {
                        ...item,
                        [e.target.name]: e.target.value,
                    };
                } else {
                    return item;
                }
            });
        }

        let new_payment = newArr;

        this.setState({
            payments: new_payment
        });

        setTimeout(this.refreshTotalShipping.bind(this), 100);
    }

    render() {
        const {
            shoppingcart, contact, data_velues, modalPaymentShow,
            cash_register_util, payments, id_payment, currencyprimary,
            currencysecondary, primary_label, secondary_label, transaction_date,
            isOpenTransactionDate, arraytransaction, payment_types_is_secondary, contact_eventual, modaltaxDescShow,
            discount_type, discount_amount, tax_id, tax_amount, taxes, pos_location_id, data_default

        } = this.state;

        let data_render_shoppingcart = [];
        if (shoppingcart && shoppingcart.length > 0) {
            data_render_shoppingcart = shoppingcart.map((val: any, key: any) =>
                this.render_shoppingcart(val, key)
            );
        }

        return (
            <IonPage className='no-print'>
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonTitle>{arraytransaction ? "Editando " + arraytransaction.invoice_no : 'Carrito'}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen scrollEvents={true}>
                    <IonGrid>
                        <IonRow align-items-center>

                            <div className='card_line'>
                                <IonRow align-items-center>
                                    <IonCol col-10 size='10'>
                                        &nbsp;<IonIcon icon={barcode} color='primary'></IonIcon>&nbsp;{contact && contact.contact_id ? contact.contact_id : ''}<br />
                                        &nbsp;<IonIcon icon={person} color='primary'></IonIcon>&nbsp;{contact && contact.name ? contact.name : ''}<br />
                                        &nbsp;<IonIcon icon={business} color='primary'></IonIcon>&nbsp;{contact && contact.supplier_business_name ? contact.supplier_business_name : ''}<br />
                                        &nbsp;<IonIcon icon={home} color='primary'></IonIcon>&nbsp;{contact && contact.address_line_1 ? contact.address_line_1 : ''}
                                    </IonCol>
                                    <IonCol col-2 size='2' className='text-center'>

                                        <IonButton size='default' className='buttomwith100'>

                                            <Link style={{ textDecoration: 'none', color: "#ffffff" }} to={"/dashboard_pos/contacts"}>
                                                <IonIcon

                                                    color="#ffffff"
                                                    slot="icon-only"
                                                    icon={receiptOutline}
                                                    size="large"
                                                />
                                            </Link>
                                        </IonButton>
                                    </IonCol>
                                    <IonCol col-10 size='10' style={{ textAlign: "center" }}>
                                        <IonButton
                                            expand="full"
                                            onClick={(e: any) => {
                                                e.persist();
                                                this.setState({ isOpenTransactionDate: true });
                                            }}
                                        >
                                            Fecha de la Venta :
                                            <Moment
                                                date={transaction_date}
                                                format="DD-MM-YYYY"
                                            />
                                        </IonButton>
                                        <IonPopover
                                            isOpen={isOpenTransactionDate}
                                            onDidDismiss={() => this.setState({ isOpenTransactionDate: false })}
                                        >
                                            <IonDatetime
                                                presentation="date"
                                                value={moment(transaction_date, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                                onIonChange={(e: any) => {
                                                    this.setState({ transaction_date: e.detail.value, isOpenTransactionDate: false });
                                                }}

                                            ></IonDatetime>
                                        </IonPopover>
                                    </IonCol>
                                    <IonCol col-2 size='2' style={{ textAlign: "center" }}>
                                        <IonButton size='default' color={'danger'} onClick={() => {
                                            if (contact_eventual && contact_eventual.id) {
                                                window.localStorage.setItem('ari_app_contact', JSON.stringify(contact_eventual));
                                            } else {
                                                window.localStorage.removeItem('ari_app_contact');
                                            }
                                            window.localStorage.setItem('ari_app_shoppingcart', JSON.stringify([]));
                                            window.localStorage.removeItem('ari_app_transaction');
                                            window.localStorage.removeItem('ari_app_transaction_payments');
                                            window.localStorage.removeItem('data_transactiotaxdic');

                                            setTimeout(this.componentDidMount.bind(this), 100);
                                        }}>
                                            <IonIcon className='icon-vertical-aling' style={{ color: "white" }} size='small' icon={trashBin} />
                                        </IonButton>
                                    </IonCol>
                                    {
                                        pos_location_id && pos_location_id > 0 ?
                                            data_default && data_default.businessLocations && data_default.businessLocations.length > 0 ?
                                                <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                                                    <strong>Ubicación de venta: {
                                                        data_default.businessLocations.filter((item_filter: any) => item_filter.id == pos_location_id).length > 0 ?
                                                            data_default.businessLocations.filter((item_filter: any) => item_filter.id == pos_location_id)[0].name
                                                            : ''
                                                    }
                                                    </strong>
                                                </IonCol> :
                                                <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                                                    <strong>Ubicación de venta no válida, seleccione otra ubicación</strong>
                                                </IonCol>
                                            :
                                            <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                                                <strong>Ubicación de venta no seleccionada, seleccione una ubicación</strong>
                                            </IonCol>
                                    }

                                </IonRow>
                            </div>

                            {data_render_shoppingcart}
                            <div className='card_line'>

                                <IonCol col-12 size='12'>
                                    <IonItem>
                                        <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                                            <IonButton size='default' color={'danger'} onClick={this.openmodaltaxDesc.bind(this)}>
                                                <IonIcon className='icon-vertical-aling' style={{ color: "white" }} size='small' icon={create} />
                                            </IonButton>
                                        </IonCol>
                                    </IonItem>
                                    <IonItem>
                                        <IonLabel>
                                            Sub-Total
                                        </IonLabel>
                                        <IonLabel slot='end' class='text-bold text-right'>
                                            <span >{data_velues && data_velues.sub_total ? _numberFormat.format(data_velues.sub_total).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span>
                                        </IonLabel>
                                    </IonItem>
                                    <IonItem>
                                        <IonLabel>
                                            Total Descuento (-)
                                        </IonLabel>
                                        <IonLabel slot='end' class='text-bold'>
                                            <span >{data_velues && data_velues.total_discount ? _numberFormat.format(data_velues.total_discount).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span>
                                        </IonLabel>
                                    </IonItem>
                                    <IonItem>
                                        <IonLabel>
                                            Impuestos
                                        </IonLabel>
                                        <IonLabel slot='end' class='text-bold'>
                                            <span >{data_velues && data_velues.total_taxes ? _numberFormat.format(data_velues.total_taxes).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span>
                                        </IonLabel>
                                    </IonItem>
                                    <IonItem>
                                        <IonLabel>
                                            Total Neto
                                        </IonLabel>
                                        <IonLabel slot='end' class='text-bold'>
                                            <span >{data_velues && data_velues.final_total ? _numberFormat.format(data_velues.final_total).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span>
                                        </IonLabel>
                                    </IonItem>
                                </IonCol>
                                {
                                    cash_register_util && cash_register_util.current_register ?

                                        <IonCol col-12 size='12' style={{ textAlign: "center", display: 'inline-block' }}>
                                            <IonButton size="default" color="azul" onClick={() => this.sendOrder('preventa')}>
                                                <strong>Pre-Venta</strong>
                                            </IonButton>
                                            <IonButton size="default" color="warning" onClick={() => this.sendOrder('quotation')}>
                                                <strong>Cotización</strong>
                                            </IonButton>
                                            <IonButton size="default" color="danger" onClick={() => this.sendOrder('is_suspend')}>
                                                <strong>Suspender</strong>
                                            </IonButton>
                                            {contact && contact.is_contado != 1 ?
                                                <IonButton size="default" color="tertiary" onClick={() => this.sendOrder('is_credit_sale')}>
                                                    <strong>Crédito</strong>
                                                </IonButton> : ''}
                                            <IonButton size="default" color="navy" onClick={() => this.openmodalPayment()}>
                                                <strong>Pago Multiple</strong>
                                            </IonButton>
                                            <IonButton size="default" color="success" onClick={() => this.sendOrder('is_payment_exist')}>
                                                <strong>Efectivo</strong>
                                            </IonButton>
                                        </IonCol> : <IonCol col-12 size='12' style={{ textAlign: "center", display: 'inline-block' }}><strong>Debe abrir caja para facturar</strong></IonCol>
                                }
                            </div>
                        </IonRow>
                    </IonGrid>

                    <IonModal
                        onWillDismiss={e => this.closemodalPayment()}
                        isOpen={modalPaymentShow}
                        trigger="open-modal"
                    /*initialBreakpoint={0.50}
                    breakpoints={[0, 0.50, 0.5, 0.75]}*/
                    >
                        <IonHeader>
                            <IonToolbar>
                                <IonTitle>Pago multiple</IonTitle>
                                <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={(ev) => this.closemodalPayment()}>
                                    <IonIcon icon={closeOutline}></IonIcon>
                                </IonButton>
                                <IonRow>
                                    <IonCol col-12 size='12'>
                                        Total a Pagar :&nbsp;
                                        <span >{data_velues && data_velues.final_total ? _numberFormat.format(data_velues.final_total).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span>&nbsp;-&nbsp;
                                        <span >{data_velues && data_velues.final_total_secondary ? _numberFormat.format(data_velues.final_total_secondary).replace("$", currencysecondary) : _numberFormat.format(0).replace("$", currencysecondary)}</span>
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        Saldo:&nbsp;
                                        <span >{data_velues && data_velues.total_rest ? _numberFormat.format(data_velues.total_rest).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span>&nbsp;-&nbsp;
                                        <span >{data_velues && data_velues.total_rest_secondary ? _numberFormat.format(data_velues.total_rest_secondary).replace("$", currencysecondary) : _numberFormat.format(0).replace("$", currencysecondary)}</span>
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        Pago total:&nbsp;
                                        <span >{data_velues && data_velues.total_paid ? _numberFormat.format(data_velues.total_paid).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span>&nbsp;-&nbsp;
                                        <span >{data_velues && data_velues.total_paid_secondary ? _numberFormat.format(data_velues.total_paid_secondary).replace("$", currencysecondary) : _numberFormat.format(0).replace("$", currencysecondary)}</span>
                                    </IonCol>
                                    <IonCol col-12 size='12'>
                                        Cambio:&nbsp;
                                        <span >{data_velues && data_velues.total_return ? _numberFormat.format(data_velues.total_return).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</span>&nbsp;-&nbsp;
                                        <span >{data_velues && data_velues.total_return_secondary ? _numberFormat.format(data_velues.total_return_secondary).replace("$", currencysecondary) : _numberFormat.format(0).replace("$", currencysecondary)}</span>
                                    </IonCol>
                                </IonRow>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            <IonRow>
                                <IonCol col-10 size='10'>
                                    {
                                        cash_register_util && cash_register_util.payment_types && cash_register_util.payment_types.length > 0 ?
                                            <Select
                                                onChange={(e: any) => this.handleChangeDefault({ target: { name: 'id_payment', value: e.value } })}
                                                placeholder="Metodos de Pago"
                                                name='id_payment'
                                                menuPortalTarget={document.querySelector('body')}
                                                isSearchable={false}
                                                options={
                                                    cash_register_util.payment_types.map((option: any) => (
                                                        { label: option.label, value: option.id }
                                                    ))
                                                }
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                }}
                                                defaultValue={id_payment ?
                                                    cash_register_util && cash_register_util.payment_types && cash_register_util.payment_types.length > 0 ?
                                                        { label: cash_register_util.payment_types.filter((item: any) => item.id == id_payment)[0].name, value: cash_register_util.payment_types.filter((item: any) => item.id == id_payment)[0].id }
                                                        : null
                                                    : null
                                                }
                                            /> : null
                                    }
                                </IonCol>
                                <IonCol col-2 size='2'>
                                    <IonButton style={{ textAling: "center", marginRight: '10px' }} onClick={(ev) => this.addPayment()}>
                                        <IonIcon icon={add}></IonIcon>
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                {
                                    payments && payments.length > 0 && payments.map((val: any, key: any) =>
                                        <>
                                            <IonCol col-12 size='12' key={key} className='card_line'>

                                                <IonRow>

                                                    <IonCol col-10 size='10' style={{ textAlign: 'left' }} >
                                                        <strong className=''> {val.label == 'cash' ? primary_label : val.label} </strong>   <br />
                                                    </IonCol>
                                                    {
                                                        key > 0 ?
                                                            <>
                                                                <IonCol col-2 size='2' style={{ textAlign: 'right' }} >
                                                                    <IonLabel color="primary" onClick={(ev) => this.removedPayment(key)} ><strong>X</strong></IonLabel>
                                                                </IonCol>
                                                            </>
                                                            : null
                                                    }

                                                    {
                                                        val.is_secondary == 0 ?
                                                            <IonCol col-6 size='6'>
                                                                {currencyprimary} <br />
                                                                <input
                                                                    autoComplete="off"
                                                                    onFocus={this.handleFocus}
                                                                    type="number"
                                                                    className='inputform input_quantity style_input'
                                                                    defaultValue={_numberFormat.format(parseFloat(val.amount)).replace("$", "")}
                                                                    min="0"
                                                                    onChange={e => this.onChangeDetailsArrayPayment(key, e)}
                                                                    name="amount" />
                                                            </IonCol>
                                                            : null
                                                    }

                                                    {
                                                        payment_types_is_secondary[val.id] && payment_types_is_secondary[val.id] == 1 ?
                                                            <IonCol col-6 size='6'>
                                                                {currencysecondary} <br />
                                                                <input autoComplete="off"
                                                                    onFocus={this.handleFocus}
                                                                    type="number"
                                                                    className='inputform input_quantity style_input'

                                                                    defaultValue={_numberFormat.format(parseFloat(val.secondary)).replace("$", "")}

                                                                    min="0"
                                                                    onChange={e => this.onChangeDetailsArrayPayment(key, e)}
                                                                    name="secondary" />
                                                            </IonCol> : null
                                                    }

                                                    <IonCol col-12 size='12'>
                                                        <label>Transacción No.: </label>

                                                        <input className='inputform' type="text" placeholder="N°" onChange={e => this.onChangeDetailsArrayPayment(key, e)} value={(val.transaction_no_2) ?? ""}
                                                            name="transaction_no_2" />

                                                    </IonCol>
                                                    <IonCol col-12 size='12'>
                                                        <label>Nota de pago: </label>

                                                        <textarea className='inputform' rows={3} placeholder="Nota de Pago" onChange={e => this.onChangeDetailsArrayPayment(key, e)} value={(val && val.note) ?? ""}
                                                            name="note" />
                                                    </IonCol>

                                                </IonRow>
                                            </IonCol>

                                        </>
                                    )
                                }
                                <IonCol col-12 size='12' style={{ textAlign: "center", display: 'inline-block' }}>
                                    <IonButton size="default" color="success" onClick={() => this.sendOrder('is_payment_exist')}>
                                        <strong>Pagar</strong>
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonContent>
                    </IonModal>
                </IonContent>

                <IonModal onDidDismiss={this.closemodaltaxDesc.bind(this)} isOpen={modaltaxDescShow} trigger="open-modal" initialBreakpoint={0.60} breakpoints={[0, 0.60, 0.5, 0.75]}>
                    <IonContent className="ion-padding">
                        <IonHeader>
                            <IonToolbar>
                                <IonTitle>Descuentos e Impuestos</IonTitle>
                                <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={this.closemodaltaxDesc.bind(this)}>
                                    <IonIcon icon={closeOutline}></IonIcon>
                                </IonButton>
                            </IonToolbar>
                        </IonHeader>

                        <IonRow>
                            <IonCol col-12 size='12'>
                                Impuesto <br />
                                {
                                    taxes && taxes.length > 0 ?
                                        <Select
                                            onChange={(e: any) => this.handleChangeDefault({ target: { name: 'tax_id', value: e.value } })}
                                            placeholder="Impuesto"
                                            name='tax_id'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={
                                                taxes && taxes.map((option: any) => (
                                                    { label: option.name, value: option.id }
                                                ))
                                            }
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={tax_id ?
                                                taxes && taxes.length > 0 ?
                                                    { label: taxes.filter((item: any) => item.id == tax_id)[0].name, value: taxes.filter((item: any) => item.id == tax_id)[0].id }
                                                    : null
                                                : null
                                            }
                                        /> : null
                                }
                            </IonCol>
                            <IonCol col-6 size='6'>
                                Tipo de descuento <br />
                                {
                                    <Select
                                        onChange={(e: any) => this.handleChangeDefault({ target: { name: 'discount_type', value: e.value } })}
                                        placeholder="Tipo de descuento"
                                        name='discount_type'
                                        menuPortalTarget={document.querySelector('body')}
                                        isSearchable={false}
                                        options={[
                                            { label: "Fijo", value: 'fixed' },
                                            { label: "Porcentaje", value: 'percentage' },
                                        ]}
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                        }}
                                        defaultValue={discount_type ?
                                            discount_type == 'fixed' ? { label: "Fijo", value: 'fixed' } : { label: "Porcentaje", value: 'percentage' }
                                            :
                                            { label: "Fijo", value: 'fixed' }
                                        }
                                    />
                                }
                            </IonCol>
                            <IonCol col-6 size='6'>
                                Monto del Descuento <br />

                                <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                                    value={discount_amount} onChange={e => this.handleChangeDefault(e)} name="discount_amount" />
                            </IonCol>

                        </IonRow>

                    </IonContent>
                </IonModal>
            </IonPage >
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        post_: (fields: any, controller: string) => dispatch(PosActions.post_(fields, controller)),
        get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
        setData_: (data: any, name: string) => dispatch(PosActions.setData(data, name)),
        removedshoppingcart: (data: any, name: string) => dispatch(PosActions.removedshoppingcart(data)),
    }
};

export default withIonLifeCycle(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Cart));

